export function getAssignedElsewhere(branchMachines, currentBranchId) {
  const taken = new Set();
  Object.entries(branchMachines || {}).forEach(([bId, mIds]) => {
    if (bId !== currentBranchId) (mIds || []).forEach(mid => taken.add(mid));
  });
  return taken;
}
